<template>
  <mdb-container fluid id="result">
    <mdb-row class="pt-3 pb-3 mb-3 d-flex blue-header">
      <mdb-col class="col-12 text-left pl-4 pr-4">
        <img
          class="logo"
          src="../assets/img/csc-white.svg"
          width="140"
          height="49"
        />
        <a
          class="link light consult-position"
          target="_blank"
          href="https://www.csc.gov.au/Employers/Contact-us"
        >
          <img
            class="icon-arrow-help"
            src="../assets/icons/big-arrow-white-outline.svg"
          />
          <span>Need help? Contact us</span>
        </a>
      </mdb-col>
    </mdb-row>

    <mdb-row class="pt-4 pb-4">
      <mdb-col class="flex-grow-7 flex-snap text-left"></mdb-col>

      <mdb-col
        class="flex-grow-3 flex-snap align-self-center text-right text-lg-left"
      >
        <WizardStep :step="3" />
      </mdb-col>
    </mdb-row>

    <mdb-row class="flex-row" responsive>
      <mdb-col
        class="flex-grow-7 flex-snap align-self-stretch ie-col-12 ie-col-lg-8 p-0 pl-sm-2 pl-md-4 pb-5 order-3 order-lg-1"
      >
        <div class="result-inset">
          <mdb-container fluid>
            <mdb-row class="text-left dots-left">
              <mdb-col
                :class="lowerCase(reviewType)"
                class="col-12 p-0 pt-2 pl-5 small-circle tiny-circle small-dot-fix"
              >
                <h3 class="tiny-screen">
                  {{ properCase(reviewType) }}
                  review on
                  {{ reviewDate }}
                  <span
                    class="tiny-screen-icon alt-small-circle alt-birthday"
                  ></span>
                </h3>
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left">
              <mdb-col class="col-12 p-0 pt-3 mt-2 pb-4 pl-5">
                <mdb-container fluid class="review-details">
                  <mdb-row>
                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label class="review-name">{{ employeeName }}</label>
                      <div class="review-data review-number">
                        {{ memberNumber }}
                      </div>
                    </mdb-col>

                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label>Date of Birth</label>
                      <div class="review-data">{{ birthDate }}</div>
                    </mdb-col>

                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label>Super Scheme</label>
                      <div class="review-data">
                        {{ formatSuperScheme(superScheme) }}
                      </div>
                    </mdb-col>

                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label>
                        {{ getFirstName(employeeName) }}'s salary as at
                        {{ reviewDate }}
                      </label>
                      <div class="review-data">
                        ${{ formatCurrency(reviewSalary) }}
                      </div>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col class="col-12 p-0 pt-2 pb-5 no-print">
                      <router-link
                        to="/about"
                        class="rounded btn btn-primary ripple-parent"
                      >
                        Edit employee
                      </router-link>
                    </mdb-col>
                  </mdb-row>

                  <mdb-row>
                    <mdb-col class="col-12 p-0 pb-1">
                      <span class="reductionNote">
                        Reductions are sorted automatically by date, in
                        ascending order.
                      </span>
                    </mdb-col>
                  </mdb-row>
                </mdb-container>
              </mdb-col>
            </mdb-row>

            <!-- REDUCTION LOOP -->
            <div :key="index" v-for="(reduction, index) in reductionData">
              <mdb-row class="text-left dots-left">
                <mdb-col
                  class="col-7 p-0 pt-2 pl-5 small-circle tiny-circle arrow-down small-dot-fix"
                >
                  <h3>
                    Reduction
                    {{ reductionNumber(index) }}
                  </h3>
                </mdb-col>

                <mdb-col class="col-5 p-0 pr-1 text-right">
                  <div
                    class="tiny-screen-icon alt-small-circle alt-arrow-down"
                  ></div>
                  <div class="reduction-header">
                    <label>Date of salary reduction</label>
                    <div class="reduction-date">
                      {{ D25(index) }}
                    </div>
                  </div>
                </mdb-col>
              </mdb-row>

              <mdb-row class="text-left dots-left">
                <mdb-col class="pl-5 pt-4 pb-4 pb-md-5">
                  <mdb-container fluid>
                    <mdb-row class="reduction-details">
                      <mdb-col
                        class="tiny-sal-reduction col-12 col-lg-6 col-xl-6 p-0 pr-5 pt-3 pb-3"
                      >
                        <label>Date of salary reduction</label>
                        <div class="reduction-data">
                          {{ D25(index) }}
                        </div>
                      </mdb-col>

                      <mdb-col
                        class="col-12 col-lg-6 col-xl-6 p-0 pr-5 pt-3 pb-3"
                      >
                        <label>
                          <span v-if="D16(index) && D21(index)">
                            Base salary as at 30/06/2003
                          </span>
                          <span v-else>
                            Base salary prior to salary reduction
                          </span>
                        </label>
                        <div class="reduction-data">
                          ${{ formatCurrency(reduction.baseSalaryPrior) }}
                        </div>
                      </mdb-col>

                      <mdb-col
                        class="col-12 col-lg-6 col-xl-6 p-0 pr-5 pt-3 pb-3"
                        v-if="superScheme === Enum.superScheme.PSS"
                      >
                        <label>
                          Is a PIP payable as a result of this reduction?
                        </label>
                        <div class="reduction-data">
                          {{ properCase(reduction.pipPayable) }}
                        </div>
                      </mdb-col>

                      <mdb-col
                        class="col-12 col-lg-6 col-xl-6 p-0 pr-5 pt-3 pb-3"
                        v-if="
                          (superScheme === Enum.superScheme.CSS ||
                            superScheme === Enum.superScheme.PSS) &&
                            D16(index)
                        "
                      >
                        <label>
                          Was a salary review completed between the date of
                          reduction and 01/07/2003?
                        </label>
                        <div class="reduction-data">
                          {{ properCase(reduction.salReviewCompleted) }}
                        </div>
                      </mdb-col>

                      <mdb-col
                        class="col-12 col-lg-6 col-xl-6 p-0 pr-5 pt-3 pb-3"
                      >
                        <label>
                          <span v-if="D16(index) && D21(index)">
                            HDA as at 30/06/2003
                          </span>
                          <span v-else>HDA prior to salary reduction</span>
                        </label>
                        <div class="reduction-data">
                          ${{ formatCurrency(reduction.hdaPrior) }}
                        </div>
                      </mdb-col>

                      <mdb-col
                        class="col-12 col-lg-6 col-xl-6 p-0 pr-5 pt-3 pb-3"
                      >
                        <label>
                          <span v-if="D16(index) && D21(index)">
                            Allowance as at 30/06/2003
                          </span>
                          <span v-else>
                            Allowance prior to salary reduction (ex HDA)
                          </span>
                        </label>
                        <div class="reduction-data">
                          ${{ formatCurrency(reduction.allowancePrior) }}
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-container>
                </mdb-col>
              </mdb-row>
            </div>
            <!-- END REDUCTION LOOP -->

            <mdb-row class="text-left dots-left">
              <mdb-col class="pl-5 pt-2 pb-5 no-print">
                &nbsp;
                <router-link
                  to="/details"
                  class="rounded btn btn-primary ripple-parent"
                  >Edit reductions</router-link
                >
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left">
              <mdb-col class="col-12 col-md-5 pt-2 pb-2 pl-5 small-circle">
                <p>
                  <router-link to="/details" class="underln">Back</router-link>
                </p>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </div>
      </mdb-col>

      <mdb-col
        class="flex-grow-3 flex-snap align-self-stretch mb-4 pt-4 pt-lg-2 pb-3 order-1 order-lg-2"
        :class="{ 'result-line': detailsExpanded }"
      >
        <div class="final-result result-circle">
          <h3>Result</h3>
          <p>Updated salary for super</p>
          <h2>${{ formatCurrency(showHighestTotal()) }}</h2>
          <p>
            <span v-if="reviewType === Enum.reviewType.BIRTHDAY">
              <span v-if="isMaintainedHigherThanActual(highestAwoteReduction)">
                {{ getFirstName(employeeName) }}'s maintained salary was higher
                than their actual salary at {{ reviewDate }}. You must use the
                AWOTE calculator again at {{ getFirstName(employeeName) }}'s
                next salary review.
              </span>
              <span v-else>
                {{ getFirstName(employeeName) }}'s actual salary was higher than
                their maintained salary at {{ reviewDate }}. You don't need to
                use the AWOTE at {{ getFirstName(employeeName) }}'s next salary
                review unless they have a further salary reduction.
              </span>
            </span>
            <span v-else>
              <span v-if="isMaintainedHigherThanActual(highestAwoteReduction)">
                {{ getFirstName(employeeName) }}'s maintained salary was higher
                than their actual salary at {{ reviewDate }}.
              </span>
              <span v-else>
                {{ getFirstName(employeeName) }}'s actual salary was higher than
                their maintained salary at {{ reviewDate }}.
              </span>
            </span>
          </p>
          <p>
            <a @click="toggleCalculationDisplay" class="underln">
              How is it calculated?
            </a>
          </p>
        </div>
        <div
          class="result-details-circle"
          :class="{ hidden: !detailsExpanded }"
        ></div>
      </mdb-col>

      <mdb-col
        class="col-12 col-lg-11 mb-4 pt-0 pb-5 order-2 order-lg-3"
        id="reductionCalculations"
      >
        <slide-up-down :active="detailsExpanded" :duration="800">
          <div class="mr-lg-5">
            <div class="text-lg-right pr-lg-4 pb-3 pb-lg-1">
              <label class="result-calc-details-1">Calculation details</label>
              <h5 class="result-calc-details-2">Updated salary for super</h5>
              <h2 class="result-calc-total">
                ${{ formatCurrency(showHighestTotal()) }}
              </h2>
              <p
                class="result-total-note tooltip-fix-mid"
                v-if="isMaintainedHigherThanActual(highestAwoteReduction)"
              >
                Salary reduction rules apply
                <mdb-tooltip
                  trigger="hover"
                  boundrySelector="#result-inset"
                  :options="{ placement: 'top' }"
                >
                  <span slot="tip">
                    As Maintained Salary is higher than the Actual Salary,
                    Salary for Super is ${{
                      formatCurrency(D32(highestAwoteReduction))
                    }}. (Salary reduction rules apply)
                  </span>
                  <span class="icon-result-question" slot="reference"></span>
                </mdb-tooltip>
              </p>
              <p class="result-total-note tooltip-fix-mid" v-else>
                Reduction rules do not apply
                <mdb-tooltip
                  trigger="hover"
                  boundrySelector="#result-inset"
                  :options="{ placement: 'top' }"
                >
                  <span slot="tip">
                    As Actual Salary (${{ formatCurrency(reviewSalary) }}) is
                    higher than the Maintained Salary, the reduction no longer
                    applies. Use the actual salary until another reduction
                    occurs.
                  </span>
                  <span class="icon-result-question" slot="reference"></span>
                </mdb-tooltip>
              </p>
            </div>

            <!-- CALCULATION RESULTS LOOP -->
            <div
              class="calculation-results p-3 mb-3 ml-md-3"
              :key="`calc-${index}`"
              v-for="(reduction, index) in reductionData"
            >
              <mdb-container fluid>
                <mdb-row class="p-0">
                  <mdb-col
                    class="flex-grow-2 flex-snap p-0 pr-2 pb-3 pb-lg-0 text-left"
                  >
                    <h4>
                      Reduction calculation
                      {{ reductionNumber(index) }}
                    </h4>
                  </mdb-col>

                  <mdb-col class="flex-grow-6 ie-col-sm-12 p-0 text-left">
                    <mdb-container fluid>
                      <mdb-row class="p-0">
                        <mdb-col
                          class="flex-grow-1 p-0 pr-3 text-left result-label"
                        >
                          <label>
                            AWOTE Rate for the date the Salary could no longer
                            be updated
                          </label>
                        </mdb-col>

                        <mdb-col
                          class="flex-grow-1 p-0 pr-3 text-left result-label"
                        >
                          <label>AWOTE Rate for the Review</label>
                        </mdb-col>
                      </mdb-row>

                      <mdb-row class="p-0">
                        <mdb-col class="flex-grow-3 p-0 pr-3 pb-2 text-left">
                          <div class="result-data">
                            ${{ formatCurrency(D29(index)) }}
                          </div>
                        </mdb-col>

                        <mdb-col class="flex-grow-3 p-0 pr-3 pb-2 text-left">
                          <div class="result-data">
                            ${{ formatCurrency(D30()) }}
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </mdb-container>
                  </mdb-col>

                  <mdb-col class="flex-grow-2 flex-snap p-0 pr-2"></mdb-col>
                </mdb-row>

                <mdb-row class="p-0">
                  <mdb-col class="flex-grow-2 flex-snap p-0 pr-2"></mdb-col>

                  <mdb-col
                    class="flex-grow-5 ie-col-sm-12 p-0 text-left d-flex"
                  >
                    <div class="result-equation result-block flex-grow-1">
                      <div>
                        <div class="result-value">
                          ${{ formatCurrency(D22(index)) }}
                        </div>
                        <span
                          class="result-multiplier"
                          v-if="
                            superScheme === Enum.superScheme.CSS ||
                              (superScheme === Enum.superScheme.PSS &&
                                D18(index))
                          "
                        >
                          x
                          {{ roundDisplay(growthFactor(index)) }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="result-equation result-add-icon flex-grow-0 align-self-center ml-2 mr-2"
                    >
                      &nbsp;
                    </div>
                    <div class="result-equation result-block flex-grow-1">
                      <div>
                        <div class="result-value">
                          ${{ formatCurrency(D23(index)) }}
                        </div>
                        <span class="result-multiplier">
                          x
                          {{ roundDisplay(growthFactor(index)) }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="result-equation result-add-icon flex-grow-0 align-self-center ml-2 mr-2"
                    >
                      &nbsp;
                    </div>
                    <div class="result-equation result-block flex-grow-1">
                      <div>
                        <div class="result-value">
                          ${{ formatCurrency(D24(index)) }}
                        </div>
                        <span class="result-multiplier">
                          x
                          {{ roundDisplay(growthFactor(index)) }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="result-equation flex-grow-0 align-self-center ml-3 mr-3 d-none d-lg-flex"
                    >
                      =
                    </div>
                  </mdb-col>

                  <mdb-col
                    class="flex-grow-3 flex-snap p-0 pt-2 pt-lg-0 text-left tooltip-fix"
                  >
                    <div>
                      <span class="result-total">
                        <span class="d-inline-block d-lg-none">
                          =
                        </span>
                        ${{ formatCurrency(D32(index)) }}
                      </span>
                      <mdb-tooltip
                        trigger="hover"
                        boundrySelector="#result-inset"
                        :options="{ placement: 'top' }"
                      >
                        <span
                          slot="tip"
                          v-if="isMaintainedHigherThanActual(index)"
                        >
                          As Maintained Salary is higher than the Actual Salary,
                          Salary for Super is ${{ formatCurrency(D32(index)) }}.
                          (Salary reduction rules apply)
                        </span>
                        <span slot="tip" v-else>
                          As Actual Salary (${{ formatCurrency(reviewSalary) }})
                          is higher than the Maintained Salary, the reduction no
                          longer applies. Use the actual salary until another
                          reduction occurs.
                        </span>
                        <span
                          class="icon-result-question"
                          slot="reference"
                        ></span>
                      </mdb-tooltip>
                    </div>

                    <div
                      class="result-total-apply"
                      v-if="
                        index === highestAwoteReduction &&
                          isMaintainedHigherThanActual(index)
                      "
                    >
                      (applied)
                    </div>
                    <div class="result-total-apply" v-else>
                      (not applied)
                    </div>

                    <div class="result-total-desc">
                      <span v-if="reviewType === Enum.reviewType.BIRTHDAY">
                        <span v-if="isMaintainedHigherThanActual(index)">
                          {{ getFirstName(employeeName) }}'s maintained salary
                          was higher than their actual salary at
                          {{ reviewDate }}. You must use the AWOTE calculator
                          again at {{ getFirstName(employeeName) }}'s next
                          salary review.
                        </span>
                        <span v-else>
                          {{ getFirstName(employeeName) }}'s actual salary was
                          higher than their maintained salary at
                          {{ reviewDate }}. You don't need to use the AWOTE at
                          {{ getFirstName(employeeName) }}'s next salary review
                          unless they have a further salary reduction.
                        </span>
                      </span>
                      <span v-else>
                        <span v-if="isMaintainedHigherThanActual(index)">
                          {{ getFirstName(employeeName) }}'s maintained salary
                          was higher than their actual salary at
                          {{ reviewDate }}.
                        </span>
                        <span v-else>
                          {{ getFirstName(employeeName) }}'s actual salary was
                          higher than their maintained salary at
                          {{ reviewDate }}.
                        </span>
                      </span>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-container>
            </div>
            <!-- END CALCULATION RESULTS LOOP -->
          </div>
        </slide-up-down>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col class="col-2"></mdb-col>

      <mdb-col class="col-12 col-lg-10 pt-3 pb-3 pt-md-0 pb-md-0 csc-btns-btm">
        <mdb-btn
          class="rounded"
          outline="primary"
          @click.native="saveAwoteText"
        >
          <i class="fas icon-txt"></i>
          Save as TXT
        </mdb-btn>

        <mdb-btn
          class="rounded"
          outline="primary"
          @click.native="saveAwoteWorksheet"
        >
          <i class="fas icon-csv"></i>
          Save as XLSX
        </mdb-btn>

        <mdb-btn class="rounded" outline="primary" @click.native="printPage">
          <i class="fas icon-pdf"></i>
          Print
        </mdb-btn>

        <mdb-btn
          class="rounded"
          color="primary"
          @click.native="showStartOver = true"
        >
          Start a new calculation
        </mdb-btn>
      </mdb-col>

      <mdb-modal :show="showStartOver" @close="showStartOver = false" centered>
        <mdb-modal-header>
          <mdb-modal-title>Start a new calculation?</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body class="text-left">
          <p v-if="!calculationSaved">
            You haven’t printed or saved this calculation. If you start over, we
            won’t save this calculation.
          </p>
          <p v-else>
            All current data will be cleared.
          </p>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn
            class="rounded"
            outline="primary"
            @click.native="showStartOver = false"
            >Cancel</mdb-btn
          >
          <mdb-btn
            class="rounded"
            color="primary"
            @click.native="startNewCalculation"
            >Start over</mdb-btn
          >
        </mdb-modal-footer>
      </mdb-modal>
    </mdb-row>

    <mdb-row class="no-gutters">
      <mdb-col>
        <Footer />
        <div id="feedback">
          <a
            href="https://feedback.csc.gov.au/cgi-bin/qwebcorporate.dll?idx=SQ6N45&type=AHC"
            target="_blank"
          >
            Feedback
          </a>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<style lang="scss">
@import "~@/scss/result.scss";
@import "~@/scss/print.scss";
</style>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTooltip
} from "mdbvue";

import { mapGetters } from "vuex";
import WizardStep from "@/components/WizardStep.vue";
import Footer from "@/components/Footer.vue";
import { scroller } from "vue-scrollto/src/scrollTo";
import SlideUpDown from "vue-slide-up-down";

function xlsDateNum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function rnd(inputVal, rndTo) {
  inputVal = parseFloat(inputVal);
  var rndMulti = 10 ** rndTo;

  return (Math.round(inputVal * rndMulti) / rndMulti).toFixed(rndTo);
}

function parseArrayDataToWorksheet(data) {
  var ws = {};
  var range = {
    s: { c: 10000000, r: 10000000 },
    e: { c: 0, r: 0 }
  };

  for (var R = 0; R != data.length; ++R) {
    for (var C = 0; C != data[R].length; ++C) {
      if (range.s.r > R) {
        range.s.r = R;
      }
      if (range.s.c > C) {
        range.s.c = C;
      }
      if (range.e.r < R) {
        range.e.r = R;
      }
      if (range.e.c < C) {
        range.e.c = C;
      }

      var cell = { v: data[R][C] };
      if (cell.v == null) {
        continue;
      }

      // eslint-disable-next-line no-undef
      var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

      if (typeof cell.v === "number") {
        cell.t = "n";
      } else if (typeof cell.v === "boolean") {
        cell.t = "b";
      } else if (cell.v instanceof Date) {
        cell.t = "n";
        // eslint-disable-next-line no-undef
        cell.z = XLSX.SSF._table[14];
        cell.v = xlsDateNum(cell.v);
      } else {
        cell.t = "s";
      }

      if (R === 0) {
        cell.s = {
          font: {
            bold: true,
            sz: 12
          }
        };
      } else if (C === 0) {
        if (
          R < 5 ||
          R === 16 ||
          R === 19 ||
          R === 26 ||
          R === 31 ||
          R === 37 ||
          R === 47 ||
          R === 52 ||
          R === 55 ||
          R === 58 ||
          R === 68 ||
          R === 73 ||
          R === 76 ||
          R === 79 ||
          R === 89 ||
          R === 94 ||
          R === 97 ||
          R === 100 ||
          R === 110 ||
          R === 115 ||
          R === 118 ||
          R === 121 ||
          R === 131 ||
          R === 136 ||
          R === 139 ||
          R === 142 ||
          R === 152 ||
          R === 157 ||
          R === 160 ||
          R === 163 ||
          R === 173 ||
          R === 178 ||
          R === 181 ||
          R === 184 ||
          R === 194 ||
          R === 199 ||
          R === 202 ||
          R === 205 ||
          R === 215 ||
          R === 220 ||
          R === 223 ||
          R === 226 ||
          R === 236 ||
          R === 241 ||
          R === 244 ||
          R === 247 ||
          R === 257 ||
          R === 262 ||
          R === 265 ||
          R === 268 ||
          R === 278 ||
          R === 283 ||
          R === 286
        ) {
          cell.s = {
            font: {
              bold: true,
              sz: 10
            }
          };
        } else {
          cell.s = {
            font: {
              sz: 10
            }
          };
        }
      } else {
        if (
          R === 33 ||
          R === 54 ||
          R === 75 ||
          R === 96 ||
          R === 117 ||
          R === 138 ||
          R === 159 ||
          R === 180 ||
          R === 201 ||
          R === 222 ||
          R === 243 ||
          R === 264 ||
          R === 285
        ) {
          cell.s = {
            font: {
              bold: true,
              sz: 10
            }
          };
        } else {
          cell.s = {
            font: {
              sz: 10
            }
          };
        }
      }

      ws[cell_ref] = cell;
    }
  }

  ws["!cols"] = [{ wch: 8 }, { wch: 8 }, { wch: 54 }, { wch: 54 }, { wch: 4 }];

  // eslint-disable-next-line no-undef
  if (range.s.c < 10000000) ws["!ref"] = XLSX.utils.encode_range(range);
  return ws;
}

function xlsxWorkbook() {
  if (!(this instanceof xlsxWorkbook)) return new xlsxWorkbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

function urlSafe(xDate) {
  return ("" + xDate).replace(/\//gi, "-");
}

export default {
  name: "Result",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,

    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,

    mdbTooltip,
    WizardStep,
    SlideUpDown,
    Footer
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "awoteData",
      "awoteNextExpectedPubDate",
      "awoteLastUpdatedUpdateText",
      "awoteNextExpectedUpdateText",
      "employeeName",
      "memberNumber",
      "birthDate",
      "superScheme",
      "reviewType",
      "reviewSalary",
      "reviewDate",
      "reductionCount",
      "reductionData",
      "formatOptions",
      "Enum"
    ])
  },

  methods: {
    runFinalCalculations() {
      for (var index = 0; index < this.reductionData.length; index++) {
        this.finalReductions.push({
          D16_reductionPriorTo1703: this.D16(index),
          D18_pipPayable: this.D18(index),
          //D19_curEquivAvailable: this.D19(index),
          D21_salReviewCompleted: this.D21(index),
          D22_allowancePrior: this.D22(index),
          D23_baseSalaryPrior: this.D23(index),
          D24_hdaPrior: this.D24(index),
          D25_reductionDate: this.D25(index),
          I26_increasedComponents: this.I26(index),
          D29_reductionDateAwote: this.D29(index),
          D30_reviewDateAwote: this.D30(),
          D32_finalCalculation: this.D32(index),
          C34_superDetermination: this.C34(index),
          growthFactorCalc: this.growthFactor(index)
        });
      }
      this.highestAwoteReduction = this.determineHighestAwoteReduction();
      window.resizeIframe();

      if (this.debugMode) {
        console.log("highestAwoteReduction: --->", this.highestAwoteReduction);
        console.log("Final Data Object:");
        console.log(this.finalReductions);
      }
    },

    determineHighestAwoteReduction() {
      var arrayPosToUse = 0;
      var lastAmount = 0;

      for (var index = 0; index < this.finalReductions.length; index++) {
        if (this.finalReductions[index].C34_superDetermination) {
          if (
            parseFloat(this.finalReductions[index].I26_increasedComponents) >
            lastAmount
          ) {
            arrayPosToUse = index;
            lastAmount = parseFloat(
              this.finalReductions[index].I26_increasedComponents
            );
          }
        } else {
          if (parseFloat(this.reviewSalary) > lastAmount) {
            arrayPosToUse = index;
            lastAmount = parseFloat(this.reviewSalary);
          }
        }
      }
      return arrayPosToUse;
    },

    properCase: value => {
      return value === null
        ? ""
        : value.toLowerCase().replace(/^(.)|\s(.)/g, function($u) {
            return $u.toUpperCase();
          });
    },

    lowerCase: value => {
      return value === null ? "" : value.toLowerCase();
    },

    getFirstName: value => {
      return value === null ? "" : value.split(" ")[0];
    },

    formatCurrency: (value, noCents = false) => {
      return value === null
        ? ""
        : noCents
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : rnd(value, 2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    roundDisplay: value => {
      return value === null ? "" : rnd(value, 3);
    },

    formatSuperScheme: value => {
      return value === null
        ? ""
        : value.length > 3
        ? value.substring(0, 3) + value.substring(3).toLowerCase()
        : value;
    },

    reductionNumber: function(index) {
      if (this.reductionCount < 2) {
        return "";
      } else {
        return index + 1;
      }
    },

    dateToNum: dateVal => {
      return dateVal === null
        ? ""
        : parseInt(
            dateVal
              .split("/")
              .reverse()
              .join("")
          );
    },

    toggleCalculationDisplay() {
      if (this.detailsExpanded) {
        this.detailsExpanded = false;
      } else {
        const scrollTo = scroller();
        this.detailsExpanded = true;
        scrollTo("#reductionCalculations");
      }
      window.triggerResize();
    },

    printPage() {
      this.calculationSaved = true;
      window.print();
    },

    startNewCalculation() {
      this.showStartOver = false;
      this.calculationSaved = false;
      this.$store.commit("resetReductions");
      this.$store.commit("resetEmployeeFields");
      this.$router.push({ name: "Home" });
    },

    /* ********* AWOTE Functions ********* */

    vlookup: function(inputDate) {
      if (this.awoteData === undefined || this.awoteData === null) {
        return false;
      } else {
        // Loop through data in chronological order, until we find the closest AWOTE date
        for (var i = 0; i < this.awoteData.length; i++) {
          if (this.awoteData[i].pubDate > inputDate) {
            // Now we've gone past it - get the previous row's rate
            return this.awoteData[i - 1].rate;
          }
        }
        // Show the last rate we have, make sure other checks are in place to ensure it is valid
        return this.awoteData[this.awoteData.length - 1].rate;
      }
    },

    getLastAwoteDate: function() {
      return this.awoteData[this.awoteData.length - 1].pubDate;
    },

    D16: function(index) {
      if (
        this.reductionData[index] === null ||
        this.reductionData[index].reductionDate === null
      ) {
        return false;
      } else {
        if (this.debugMode) {
          console.log(
            "D16 Calculation:",
            "[" + index + "] --------------------------------"
          );
          console.log(
            "reductionDate:",
            this.dateToNum(this.D25(index)),
            "<",
            this.Enum.july2003
          );
        }

        return this.dateToNum(this.D25(index)) < this.Enum.july2003;
      }
    },

    D18: function(index) {
      if (
        this.reductionData[index] === undefined ||
        this.reductionData[index] === null ||
        this.reductionData[index].pipPayable === undefined ||
        this.reductionData[index].pipPayable === null
      ) {
        return false;
      } else {
        if (this.debugMode) {
          console.log(
            "D18 Calculation:",
            "[" + index + "] --------------------------------"
          );
          console.log("Super Scheme:", this.superScheme);
          console.log("PIP Payable:", this.reductionData[index].pipPayable);
        }
        return (
          this.superScheme === this.Enum.superScheme.PSS &&
          this.reductionData[index].pipPayable === this.Enum.btnVal.YES
        );
      }
    },

    D21: function(index) {
      if (
        this.reductionData[index] === null ||
        this.reductionData[index].salReviewCompleted === null
      ) {
        return false;
      } else {
        return (
          (this.superScheme === this.Enum.superScheme.CSS ||
            this.superScheme === this.Enum.superScheme.PSS) &&
          this.reductionData[index].salReviewCompleted === this.Enum.btnVal.YES
        );
      }
    },

    D22: function(index) {
      return this.reductionData[index].allowancePrior;
    },

    I22: function(index) {
      if (
        (this.superScheme === this.Enum.superScheme.PSS ||
          this.superScheme === this.Enum.superScheme.PSSAP) &&
        this.D18(index) === false // Inverse if conditions compared to D32 - should consolidate if using
      ) {
        return this.D22(index);
      } else {
        return rnd(this.D22(index) * this.growthFactor(index), 3);
      }
    },

    D23: function(index) {
      return this.reductionData[index].baseSalaryPrior;
    },

    I23: function(index) {
      return rnd(this.D23(index) * this.growthFactor(index), 3);
    },

    D24: function(index) {
      return this.reductionData[index].hdaPrior;
    },

    I24: function(index) {
      return rnd(this.D24(index) * this.growthFactor(index), 3);
    },

    D25: function(index) {
      return this.reductionData[index].reductionDate;
    },

    I26: function(index) {
      // Should be the same output as D32.. overall calculations are the same, but separated

      if (this.debugMode) {
        let _I22 = parseFloat(this.I22(index));
        let _I23 = parseFloat(this.I23(index));
        let _I24 = parseFloat(this.I24(index));
        console.log(
          "I26 Calculation:",
          "[" + index + "] --------------------------------"
        );
        console.log(
          "I22:",
          _I22,
          "I23:",
          _I23,
          "I24:",
          _I24,
          "Total:",
          rnd(_I22 + _I23 + _I24, 2)
        );
      }

      return rnd(
        parseFloat(this.I22(index)) +
          parseFloat(this.I23(index)) +
          parseFloat(this.I24(index)),
        2
      );
    },

    D29: function(index) {
      if (this.debugMode) {
        console.log(
          "D29 Calculation:",
          "[" + index + "] --------------------------------"
        );
        if (
          (this.superScheme === this.Enum.superScheme.CSS ||
            this.superScheme === this.Enum.superScheme.PSS) &&
          this.D16(index) &&
          this.D21(index)
        ) {
          console.log(
            "vLookup D25/reductionDate*:",
            this.Enum.july2003,
            this.vlookup(this.Enum.july2003)
          );
        } else {
          console.log(
            "vLookup D25/reductionDate:",
            this.dateToNum(this.D25(index)),
            this.vlookup(this.dateToNum(this.D25(index)))
          );
        }
      }

      if (
        (this.superScheme === this.Enum.superScheme.CSS ||
          this.superScheme === this.Enum.superScheme.PSS) &&
        this.D16(index) &&
        this.D21(index)
      ) {
        return this.vlookup(this.Enum.july2003);
      } else {
        return this.vlookup(this.dateToNum(this.D25(index)));
      }
    },

    D30: function() {
      if (this.debugMode) {
        console.log("D30 Calculation: --------------------------------");
        console.log(
          "vLookup reviewDate:",
          this.dateToNum(this.reviewDate),
          this.vlookup(this.dateToNum(this.reviewDate))
        );
      }

      return this.vlookup(this.dateToNum(this.reviewDate));
    },

    // D31
    growthFactor: function(index) {
      var value = 1 + (this.D30() - this.D29(index)) / this.D29(index);
      if (this.superScheme === this.Enum.superScheme.CSS) {
        return value < 1 ? 1 : value;
      } else {
        return value < 1 ? "1.000" : value.toFixed(3);
      }
    },

    D32: function(index) {
      if (
        this.superScheme === this.Enum.superScheme.CSS ||
        this.D18(index) === true
      ) {
        // 1. CSS
        // 2. PSS + PIP
        if (this.debugMode) {
          let _gFactor = parseFloat(this.growthFactor(index));
          let _D22 = this.D22(index);
          let _D22plus = rnd(_D22 * _gFactor, 3);
          let _D23 = this.D23(index);
          let _D23plus = rnd(_D23 * _gFactor, 3);
          let _D24 = this.D24(index);
          let _D24plus = rnd(_D24 * _gFactor, 3);

          console.log(
            "D32 Calculation:",
            "[" + index + "] --------------------------------"
          );
          console.log("growthFactor:", _gFactor);
          console.log("D22:", _D22, "/ D22 * growthFactor:", _D22plus, "+");
          console.log("D23:", _D23, "/ D23 * growthFactor:", _D23plus, "+");
          console.log("D24:", _D24, "/ D24 * growthFactor:", _D24plus);
          console.log(
            "D32:",
            parseFloat(_D22plus) + parseFloat(_D23plus) + parseFloat(_D24plus)
          );
        }

        return rnd(
          parseFloat(
            rnd(this.D22(index) * parseFloat(this.growthFactor(index)), 3)
          ) +
            parseFloat(
              rnd(this.D23(index) * parseFloat(this.growthFactor(index)), 3)
            ) +
            parseFloat(
              rnd(this.D24(index) * parseFloat(this.growthFactor(index)), 3)
            ),
          2
        );
      } else {
        // 3. PSS + No PIP
        // 4. PSSap
        if (this.debugMode) {
          let _gFactor = parseFloat(this.growthFactor(index));
          let _D22 = this.D22(index);
          let _D23 = this.D23(index);
          let _D23plus = rnd(_D23 * _gFactor, 3);
          let _D24 = this.D24(index);
          let _D24plus = rnd(_D24 * _gFactor, 3);

          console.log(
            "D32 Calculation:",
            "[" + index + "] --------------------------------"
          );
          console.log("growthFactor:", _gFactor);
          console.log("D22:", _D22, "+");
          console.log("D23:", _D23, "/ D23 * growthFactor:", _D23plus, "+");
          console.log("D24:", _D24, "/ D24 * growthFactor:", _D24plus);
          console.log(
            "D32:",
            parseFloat(_D22) + parseFloat(_D23plus) + parseFloat(_D24plus)
          );
        }

        return rnd(
          this.D22(index) * 1 +
            parseFloat(
              rnd(this.D23(index) * parseFloat(this.growthFactor(index)), 3)
            ) +
            parseFloat(
              rnd(this.D24(index) * parseFloat(this.growthFactor(index)), 3)
            ),
          2
        );
      }
    },

    // Salary for Super determination
    C34: function(index) {
      if (this.debugMode) {
        let _D32 = parseFloat(this.D32(index));
        let _I26 = parseFloat(this.I26(index));
        let _reviewSalary = parseFloat(this.reviewSalary);
        console.log(
          "C34 Calculation:",
          "[" + index + "] --------------------------------"
        );
        console.log(
          "D32:",
          _D32,
          "aka I26:",
          _I26,
          ">",
          "ReviewSalary:",
          _reviewSalary,
          "Result:",
          _I26 > _reviewSalary
        );
      }

      //return parseFloat(this.I26(index)) > parseFloat(this.reviewSalary);
      return parseFloat(this.D32(index)) > parseFloat(this.reviewSalary);
    },

    isMaintainedHigherThanActual: function(index) {
      if (
        this.finalReductions[index] === undefined ||
        this.finalReductions[index] === null ||
        this.finalReductions[index].C34_superDetermination === undefined ||
        this.finalReductions[index].C34_superDetermination === null
      ) {
        return false;
      } else {
        if (this.finalReductions[index].C34_superDetermination) {
          return true;
        } else {
          return false;
        }
      }
    },

    showHighestTotal: function() {
      if (
        this.finalReductions[this.highestAwoteReduction] === undefined ||
        this.finalReductions[this.highestAwoteReduction] === null ||
        this.finalReductions[this.highestAwoteReduction]
          .C34_superDetermination === undefined ||
        this.finalReductions[this.highestAwoteReduction]
          .C34_superDetermination === null
      ) {
        return false;
      } else {
        if (
          this.finalReductions[this.highestAwoteReduction]
            .C34_superDetermination
        ) {
          return this.finalReductions[this.highestAwoteReduction]
            .D32_finalCalculation;
        } else {
          return this.reviewSalary;
        }
      }
    },

    /* ********* End AWOTE Functions ********* */

    getSinglePassXLSSheetData: function() {
      var xlsData = [["Average Weekly Ordinary Time Earnings"]]; // Row 1
      xlsData.push(["(AWOTE) Calculator"]); // Row 2
      xlsData.push([]); // Row 3

      xlsData.push([
        "AWOTE rates last updated " +
          this.awoteLastUpdatedUpdateText +
          ". Next expected release is " +
          this.awoteNextExpectedUpdateText +
          "."
      ]); // Row 4

      xlsData.push([]); // Row 5
      xlsData.push([]); // Row 6
      xlsData.push([]); // Row 7
      xlsData.push([]); // Row 8

      xlsData.push([
        "Review type:",
        null,
        null,
        this.properCase(this.reviewType)
      ]); // Row 9

      xlsData.push(["Employee name:", null, null, this.employeeName]); // Row 10

      xlsData.push(["AGS / Member number:", null, null, this.memberNumber]); // Row 11

      xlsData.push(["Date of Birth (dd/mm/yyyy):", null, null, this.birthDate]); // Row 12

      xlsData.push([
        "Date of review (dd/mm/yyyy):",
        null,
        null,
        this.reviewDate
      ]); // Row 13

      xlsData.push([
        "Salary as at date of review",
        null,
        null,
        "$" + this.formatCurrency(this.reviewSalary)
      ]); // Row 14

      xlsData.push([
        "Super scheme:",
        null,
        null,
        this.formatSuperScheme(this.superScheme)
      ]); // Row 15

      return xlsData;
    },

    getLoopingXLSSheetData: function(
      reductionIndex,
      reductionsGenerated,
      showWarning = false
    ) {
      var xlsData = [];

      if (reductionsGenerated >= 1) {
        xlsData.push([]); // Row 20

        if (this.finalReductions.length > 1) {
          xlsData.push(["Reduction #" + (reductionIndex + 1)]); // Row 17
        } else {
          xlsData.push([]); // Row 17
        }

        xlsData.push([
          "Was Salary Reduction prior to 1/7/2003?",
          null,
          null,
          this.finalReductions[reductionIndex].D16_reductionPriorTo1703 === true
            ? "Yes"
            : "No"
        ]); // Row 16
      } else {
        xlsData.push([
          "Was Salary Reduction prior to 1/7/2003?",
          null,
          null,
          this.finalReductions[reductionIndex].D16_reductionPriorTo1703 === true
            ? "Yes"
            : "No"
        ]); // Row 16

        if (this.finalReductions.length > 1) {
          xlsData.push(["Reduction #" + (reductionIndex + 1)]); // Row 17
        } else {
          xlsData.push([]); // Row 17
        }
      }

      if (this.superScheme === this.Enum.superScheme.PSS) {
        xlsData.push([
          "Is a PIP payable as a result of this reduction?",
          null,
          null,
          this.finalReductions[reductionIndex].D18_pipPayable === true
            ? "Yes"
            : "No"
        ]); // Row 18
      } else {
        xlsData.push([]); // Row 18
      }

      xlsData.push([]); // Row 19

      if (reductionsGenerated < 1) {
        xlsData.push([]); // Row 20
      }

      if (
        (this.superScheme === this.Enum.superScheme.CSS ||
          this.superScheme === this.Enum.superScheme.PSS) &&
        this.finalReductions[reductionIndex].D16_reductionPriorTo1703 === true
      ) {
        xlsData.push([
          "Was a salary review completed between the date of reduction and 01/07/2003?",
          null,
          null,
          this.finalReductions[reductionIndex].D21_salReviewCompleted === true
            ? "Yes"
            : "No"
        ]); // Row 21
      } else {
        xlsData.push([]); // Row 21
      }

      if (
        this.finalReductions[reductionIndex].D16_reductionPriorTo1703 ===
          true &&
        this.finalReductions[reductionIndex].D18_pipPayable === true
      ) {
        xlsData.push([
          "Allowance as at 30/06/2003",
          null,
          null,
          "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D22_allowancePrior
            )
        ]); // Row 22
      } else {
        xlsData.push([
          "Allowance prior to salary reduction (ex HDA)",
          null,
          null,
          "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D22_allowancePrior
            )
        ]); // Row 22
      }

      if (
        (this.superScheme === this.Enum.superScheme.CSS ||
          this.superScheme === this.Enum.superScheme.PSS) &&
        this.finalReductions[reductionIndex].D16_reductionPriorTo1703 === true
      ) {
        xlsData.push([
          "Base salary as at 30/06/2003",
          null,
          null,
          "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D23_baseSalaryPrior
            )
        ]); // Row 23
      } else {
        xlsData.push([
          "Base salary prior to salary reduction",
          null,
          null,
          "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D23_baseSalaryPrior
            )
        ]); // Row 23
      }

      if (
        this.finalReductions[reductionIndex].D16_reductionPriorTo1703 ===
          true &&
        this.finalReductions[reductionIndex].D18_pipPayable === true
      ) {
        xlsData.push([
          "HDA as at 30/06/2003",
          null,
          null,
          "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D24_hdaPrior
            )
        ]); // Row 24
      } else {
        xlsData.push([
          "HDA prior to salary reduction",
          null,
          null,
          "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D24_hdaPrior
            )
        ]); // Row 24
      }

      xlsData.push([
        "What was the date of this salary reduction?",
        null,
        null,
        this.finalReductions[reductionIndex].D25_reductionDate
      ]); // Row 25

      xlsData.push([]); // Row 26

      if (
        reductionIndex === this.highestAwoteReduction &&
        this.isMaintainedHigherThanActual(reductionIndex)
      ) {
        xlsData.push(["AWOTE Calculation (applied)"]); // Row 27
      } else {
        xlsData.push(["AWOTE Calculation (not applied)"]); // Row 27
      }

      xlsData.push([]); // Row 28

      xlsData.push([
        "a) AWOTE Rate for the date the Salary could no longer be updated:",
        null,
        null,
        "$" +
          this.formatCurrency(
            this.finalReductions[reductionIndex].D29_reductionDateAwote
          )
      ]); // Row 29

      xlsData.push([
        "b) AWOTE Rate for the Review:",
        null,
        null,
        "$" +
          this.formatCurrency(
            this.finalReductions[reductionIndex].D30_reviewDateAwote
          )
      ]); // Row 30

      if (
        this.superScheme === this.Enum.superScheme.CSS ||
        this.finalReductions[reductionIndex].D18_pipPayable === true
      ) {
        xlsData.push([
          null,
          null,
          null,
          "= ($" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D22_allowancePrior
            ) +
            " x " +
            this.finalReductions[reductionIndex].growthFactorCalc +
            ") + ($" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D23_baseSalaryPrior
            ) +
            " x " +
            this.finalReductions[reductionIndex].growthFactorCalc +
            ") + ($" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D24_hdaPrior
            ) +
            " x " +
            this.finalReductions[reductionIndex].growthFactorCalc +
            ")"
        ]); // Row 31
      } else {
        xlsData.push([
          null,
          null,
          null,
          "= $" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D22_allowancePrior
            ) +
            " + ($" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D23_baseSalaryPrior
            ) +
            " x " +
            this.finalReductions[reductionIndex].growthFactorCalc +
            ") + ($" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D24_hdaPrior
            ) +
            " x " +
            this.finalReductions[reductionIndex].growthFactorCalc +
            ")"
        ]); // Row 31
      }

      xlsData.push([
        "Updated salary for super =",
        null,
        null,
        "$" +
          this.formatCurrency(
            this.finalReductions[reductionIndex].D32_finalCalculation
          )
      ]); // Row 32

      xlsData.push([]); // Row 33

      if (
        this.finalReductions[reductionIndex].C34_superDetermination === true
      ) {
        xlsData.push([
          "Salary for Super",
          null,
          "As Maintained Salary is higher than the Actual Salary, Salary for Super is $" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D32_finalCalculation
            ) +
            " (Salary reduction rules apply)"
        ]); // Row 34
      } else {
        xlsData.push([
          "Salary for Super",
          null,
          "As Actual Salary $" +
            this.formatCurrency(this.reviewSalary) +
            " is higher than the Maintained Salary, the reduction no longer applies. Use the actual salary until another reduction occurs."
        ]); // Row 34
      }
      if (showWarning) {
        xlsData.push([
          "This salary was not applied as this was not the highest result."
        ]); // Row 35
      } else {
        xlsData.push([]); // Row 35
      }

      xlsData.push([]); // Row 36

      return xlsData;
    },

    saveAwoteWorksheet: function() {
      var awoteWorkbook = new xlsxWorkbook();
      var worksheetName = "";
      var reductionIndex = 0;
      var reductionsGenerated = 0;

      // Single Sheet Output
      var xlsData = this.getSinglePassXLSSheetData();

      // Get applied Reduction first
      for (
        reductionIndex = 0;
        reductionIndex < this.finalReductions.length;
        reductionIndex++
      ) {
        if (
          reductionIndex === this.highestAwoteReduction &&
          this.isMaintainedHigherThanActual(reductionIndex)
        ) {
          xlsData = xlsData.concat(
            this.getLoopingXLSSheetData(reductionIndex, reductionsGenerated)
          );
          reductionsGenerated++;
        }
      }

      // Now get any others
      for (
        reductionIndex = 0;
        reductionIndex < this.finalReductions.length;
        reductionIndex++
      ) {
        if (
          reductionIndex === this.highestAwoteReduction &&
          this.isMaintainedHigherThanActual(reductionIndex)
        ) {
          // Do nothing
        } else {
          xlsData = xlsData.concat(
            this.getLoopingXLSSheetData(
              reductionIndex,
              reductionsGenerated,
              true
            )
          );
          reductionsGenerated++;
        }
      }

      worksheetName = "Awote Result";

      var resultWorksheet = parseArrayDataToWorksheet(xlsData);
      awoteWorkbook.SheetNames.push(worksheetName);
      awoteWorkbook.Sheets[worksheetName] = resultWorksheet;

      // eslint-disable-next-line no-undef
      var finalWorkbook = XLSX.write(awoteWorkbook, {
        bookType: "xlsx",
        bookSST: true,
        type: "binary"
      });

      this.calculationSaved = true;

      // eslint-disable-next-line no-undef
      saveAs(
        new Blob([s2ab(finalWorkbook)], { type: "application/octet-stream" }),
        "AWOTE Result - " +
          this.employeeName +
          " (" +
          urlSafe(this.reviewDate) +
          ").xlsx"
      );
    },

    getTextData() {
      let nl = "\n";

      var textData =
        "Average Weekly Ordinary Time Earnings" +
        nl +
        "(AWOTE) Calculator" +
        nl +
        nl +
        "AWOTE rates last updated " +
        this.awoteLastUpdatedUpdateText +
        ". Next expected release is " +
        this.awoteNextExpectedUpdateText +
        "." +
        nl +
        nl +
        "Employee name: " +
        this.employeeName +
        nl +
        "AGS / Member number: " +
        this.memberNumber +
        nl +
        "Date of Birth (dd/mm/yyyy): " +
        this.birthDate +
        nl +
        "Date of review (dd/mm/yyyy): " +
        this.reviewDate +
        nl +
        "Review Type: " +
        this.properCase(this.reviewType) +
        nl +
        "Salary as at date of review: $" +
        this.formatCurrency(this.reviewSalary) +
        nl +
        "Super Scheme: " +
        this.formatSuperScheme(this.superScheme) +
        nl +
        nl;

      return textData;
    },

    getTextReductionData(appliedReductionOnly = false) {
      let nl = "\n";
      var reductionData = "";
      var processLoop = false;

      for (
        var reductionIndex = 0;
        reductionIndex < this.finalReductions.length;
        reductionIndex++
      ) {
        if (appliedReductionOnly) {
          if (
            reductionIndex === this.highestAwoteReduction &&
            this.isMaintainedHigherThanActual(reductionIndex)
          ) {
            processLoop = true;
          } else {
            processLoop = false;
          }
        } else {
          if (
            reductionIndex === this.highestAwoteReduction &&
            this.isMaintainedHigherThanActual(reductionIndex)
          ) {
            processLoop = false;
          } else {
            processLoop = true;
          }
        }

        if (processLoop) {
          if (this.finalReductions.length > 1) {
            reductionData +=
              nl + "Reduction #" + (reductionIndex + 1) + ":" + nl + nl;
          }

          reductionData +=
            "Was Salary Reduction prior to 1/7/2003? " +
            (this.finalReductions[reductionIndex].D16_reductionPriorTo1703 ===
            true
              ? "Yes"
              : "No") +
            nl +
            nl; // Row 16

          if (this.superScheme === this.Enum.superScheme.PSS) {
            reductionData +=
              "Is a PIP payable as a result of this reduction? " +
              (this.finalReductions[reductionIndex].D18_pipPayable === true
                ? "Yes"
                : "No") +
              nl; // Row 18
          }

          if (
            (this.superScheme === this.Enum.superScheme.CSS ||
              this.superScheme === this.Enum.superScheme.PSS) &&
            this.finalReductions[reductionIndex].D16_reductionPriorTo1703 ===
              true
          ) {
            "Was a salary review completed between the date of reduction and 01/07/2003? " +
              (this.finalReductions[reductionIndex].D21_salReviewCompleted ===
              true
                ? "Yes"
                : "No") +
              nl; // Row 21
          }

          if (
            (this.superScheme === this.Enum.superScheme.CSS ||
              this.superScheme === this.Enum.superScheme.PSS) &&
            this.finalReductions[reductionIndex].D16_reductionPriorTo1703 ===
              true
          ) {
            reductionData +=
              "Allowance as at 30/06/2003: " +
              this.finalReductions[reductionIndex].D22_allowancePrior +
              nl; // Row 22

            reductionData +=
              "Base salary as at 30/06/2003: " +
              this.finalReductions[reductionIndex].D23_baseSalaryPrior +
              nl; // Row 23

            reductionData +=
              "HDA as at 30/06/2003: " +
              this.finalReductions[reductionIndex].D24_hdaPrior +
              nl; // Row 24
          } else {
            reductionData +=
              "Allowance prior to salary reduction (ex HDA): " +
              this.finalReductions[reductionIndex].D22_allowancePrior +
              nl; // Row 22

            reductionData +=
              "Base salary prior to salary reduction: " +
              this.finalReductions[reductionIndex].D23_baseSalaryPrior +
              nl; // Row 23

            reductionData +=
              "HDA prior to salary reduction: " +
              this.finalReductions[reductionIndex].D24_hdaPrior +
              nl; // Row 24
          }

          reductionData +=
            "What was the date of this salary reduction?: " +
            this.finalReductions[reductionIndex].D25_reductionDate +
            nl +
            nl;

          if (
            reductionIndex === this.highestAwoteReduction &&
            this.isMaintainedHigherThanActual(reductionIndex)
          ) {
            reductionData += "AWOTE Calculation (applied)" + nl + nl; // Row 27
          } else {
            reductionData += "AWOTE Calculation (not applied)" + nl + nl; // Row 27
          }

          reductionData +=
            "a) AWOTE Rate for the date the Salary could no longer be updated: " +
            "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D29_reductionDateAwote
            ) +
            nl; // Row 29

          reductionData +=
            "b) AWOTE Rate for the Review: " +
            "$" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D30_reviewDateAwote
            ) +
            nl +
            nl; // Row 30

          if (
            this.superScheme === this.Enum.superScheme.CSS ||
            this.finalReductions[reductionIndex].D18_pipPayable === true
          ) {
            reductionData +=
              "= ($" +
              this.formatCurrency(
                this.finalReductions[reductionIndex].D22_allowancePrior
              ) +
              " x " +
              this.finalReductions[reductionIndex].growthFactorCalc +
              ") + ($" +
              this.formatCurrency(
                this.finalReductions[reductionIndex].D23_baseSalaryPrior
              ) +
              " x " +
              this.finalReductions[reductionIndex].growthFactorCalc +
              ") + ($" +
              this.formatCurrency(
                this.finalReductions[reductionIndex].D24_hdaPrior
              ) +
              " x " +
              this.finalReductions[reductionIndex].growthFactorCalc +
              ")" +
              nl +
              nl; // Row 31
          } else {
            reductionData +=
              "= $" +
              this.formatCurrency(
                this.finalReductions[reductionIndex].D22_allowancePrior
              ) +
              " + ($" +
              this.formatCurrency(
                this.finalReductions[reductionIndex].D23_baseSalaryPrior
              ) +
              " x " +
              this.finalReductions[reductionIndex].growthFactorCalc +
              ") + ($" +
              this.formatCurrency(
                this.finalReductions[reductionIndex].D24_hdaPrior
              ) +
              " x " +
              this.finalReductions[reductionIndex].growthFactorCalc +
              ")" +
              nl +
              nl; // Row 31
          }

          var appliedText = " (not applied)";
          var notAppliedDescription =
            "This salary was not applied as this was not the highest result." +
            nl +
            nl;
          if (
            reductionIndex === this.highestAwoteReduction &&
            this.isMaintainedHigherThanActual(reductionIndex)
          ) {
            appliedText = " (applied)";
            notAppliedDescription = nl;
          }

          reductionData +=
            "Updated salary for super = $" +
            this.formatCurrency(
              this.finalReductions[reductionIndex].D32_finalCalculation
            ) +
            appliedText +
            nl +
            nl; // Row 32

          reductionData += "Salary for Super" + nl + nl;

          if (
            this.finalReductions[reductionIndex].C34_superDetermination === true
          ) {
            reductionData +=
              "As Maintained Salary is higher than the Actual Salary, Salary for Super is $" +
              this.formatCurrency(
                this.finalReductions[reductionIndex].D32_finalCalculation
              ) +
              " (Salary reduction rules apply)" +
              nl; // Row 34
          } else {
            reductionData +=
              "As Actual Salary $" +
              this.formatCurrency(this.reviewSalary) +
              " is higher than the Maintained Salary, the reduction no longer applies. Use the actual salary until another reduction occurs." +
              nl; // Row 34
          }

          reductionData += notAppliedDescription;
        }
      }

      return reductionData;
    },

    saveAwoteText() {
      var finalAwoteText = this.getTextData();
      finalAwoteText += this.getTextReductionData(true);
      finalAwoteText += this.getTextReductionData();
      var blob = new Blob([finalAwoteText], {
        type: "text/plain;charset=utf-8"
      });

      this.calculationSaved = true;

      // eslint-disable-next-line no-undef
      saveAs(
        blob,
        "AWOTE Result - " +
          this.employeeName +
          " (" +
          urlSafe(this.reviewDate) +
          ").txt"
      );
    }
  },

  mounted() {
    // Check we have a populated datastore, redirect if not
    if (
      this.$store.state.employeeName === null ||
      this.$store.state.employeeName.length < 1
    ) {
      this.$router.push({ name: "Home" });
    }
    this.runFinalCalculations();

    if (document.getElementById("xlsScripts")) {
      return; // was already loaded
    } else {
      var xlsScript1 = document.createElement("script");
      var xlsScript2 = document.createElement("script");
      var xlsScript3 = document.createElement("script");
      xlsScript1.id = "xlsScripts";
      xlsScript1.src = "xls/xlsx.core.min.js";
      xlsScript2.src = "xls/Blob.js";
      xlsScript3.src = "xls/FileSaver.js";
      document.getElementsByTagName("head")[0].appendChild(xlsScript1);
      document.getElementsByTagName("head")[0].appendChild(xlsScript2);
      document.getElementsByTagName("head")[0].appendChild(xlsScript3);
    }
    window.triggerResize();
  },

  data() {
    return {
      finalReductions: [],
      highestAwoteReduction: 0,
      detailsExpanded: false,
      noAwoteWarning: false,
      calculationSaved: false,
      showStartOver: false
    };
  }
};
</script>
